export default {
  methods: {
    addEmptyAction() {
      this.rule.actions.push({
        data: {},
        fields: {},
        key: null,
      });
    },
    handleClose() {
      this.rule = {
        title: null,
        events: null,
        campaign: 1,
        actions: [],
        conditions: [],
      };
      this.$emit('close');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/rules.js